export default (props, vars) => [vars?.['useuser1']?.['user']];
